import { AfterViewInit, Component } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive>
        <ng-content select="nb-menu"></ng-content>
        <br/><br/><br/>        
        <div style="text-align: center; cursor: pointer;" id="sentry-button"><a><i class="fa fa-bullhorn" aria-hidden="true"></i> Fout gezien?</a></div>                                                  
      </nb-sidebar>

      <nb-layout-column>      
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer>      
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    const feedback = Sentry.getFeedback();
    feedback?.attachTo(document.querySelector('#sentry-button'));
  }
}
